var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-container',{attrs:{"fluid":this.$vuetify.breakpoint.mdAndDown}},[_c('div',{staticClass:"pt-4 px-4"},[_c('fma-lookahead',{attrs:{"items":_vm.searchTerms,"on-search-submit":_vm.searchSubmitted}})],1),_c('h1',{class:[
        this.$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-3',
        'secondary--text',
        'font-weight-bold',
        'pl-4',
        'pt-2'
      ]},[_vm._v("\n      Categories\n    ")]),_c('tile-grid',_vm._l((_vm.categories),function({ title, description, image_id, id }){return _c('v-flex',{key:id,class:`lg${_vm.tileWidth}`,style:(`max-width: ${(_vm.tileWidth / 12) * 100}%;`)},[_c('fma-tile',{attrs:{"title":title,"description":description,"imgsrc":_vm.images[image_id],"button-text":"Learn More","action-on-tile-click":() => _vm.categoryClicked(id)}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }